import { IDeleteControlePatrimonioUseCase } from "../../../presentation/useCases/delete/delete_controle_patrimonio_use_case";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * DeleteControlePatrimonioUseCase
 */

export class DeleteControlePatrimonioUseCase implements IDeleteControlePatrimonioUseCase {
  constructor(
    private readonly repository: IRhRepository,
  ) { }

  async deleteControlePatrimonio(idControlePatrimonio: number): Promise<void> {
    await this.repository.deleteControlePatrimonio(idControlePatrimonio);
  }
}